<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" ></prox-main>

<ng-template #bodyTemplate>

  <div class="card-body grow flex flex-col">
    <div class="flex">
      <div class="flex flex-1 width: 100px">
        <ul class="list-none p-0 m-0">
          <li class="flex justify-between mb-1">
            <span>Current Status: {{program.activeStatus.name}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="w-1/3 pb-3 pr-3">
      <prox-field label="Change Status To: ">
        <!-- <p-dropdown [options]="nextStatusOptions" [(ngModel)]="selectedNextStatus" optionLabel="name" optionValue="id"
          name="nextStatusOption" (onChange)="onChangeNextStatus($event)"></p-dropdown> -->
        <p-select [options]="nextStatusOptions" [(ngModel)]="selectedNextStatus" optionLabel="name" optionValue="id"
          name="nextStatusOption" (onChange)="onChangeNextStatus($event)" class="w-full"></p-select>
      </prox-field>
    </div>
  </div>
  <prox-save-cancel [uow]="this" (undo)="onCancel()" (save)="onSave()" (cancel)="onCancel()"></prox-save-cancel>
</ng-template>
